import { connect } from 'react-redux';

import Loading from '../components/modals/loading';

const mapStateToProps = state => ({
  numberOfItemsAwaitingReady: state.scene.numberOfItemsAwaitingReady,
});

const LoadingModal = connect(mapStateToProps)(Loading);

export default LoadingModal;
